import React from 'react'
import { Box, Typography} from '@mui/material';

//import assets
import webtexts from '../../../assets/webtexts.json'
import { ScrollFadeInSlideUp } from '../../../components';

const AboutPurpose = () => {
    const purposeData = [
        {
          name:'Mission', 
          text:`At Pangu, our mission is to transform visions into reality by delivering exceptional construction solutions that surpass industry standards. We are dedicated in providing innovative, sustainable, and high-quality projects that not only meet but exceed the expectations of our clients. `, 
          gridRow:'1', 
          gridColumn:'1'
        },
        {
          name:'Vision', 
          text:`At Pangu, our vision is to redefine industry standards by delivering unparalleled excellence in every project. We aspire to be a leading force in the field of construction and renovation, setting new benchmarks for quality,safety, and innovation.`, 
          gridRow:'2', 
          gridColumn:'2'
        },
        {
          name:'Values', 
          text:`Our commitment extends beyond construction; we aim to contribute positively to the communities we serve and set new benchmarks for excellence in the industry.`, 
          gridRow:'3', 
          gridColumn:'3'
        },
      ]
    
      const PurposeContainer = ({name, text, sx}) => {
        return (
          <ScrollFadeInSlideUp direction='left' sx={sx} threshold='0.8'>
            <Box
              sx={{
                ...sx,
                // minHeight:'30%',
                width:'100%',
                background:'linear-gradient(to right, rgba(109, 116, 198, 1),  rgba(109, 116, 198, 0))',
                padding:'2rem',
                borderRadius:'1rem 0 0 1rem',
                boxSizing:'border-box'
              }}
            >
              <Typography variant='h1'
                sx={{
                  fontFamily:"var(--title-font)",
                  fontSize:'2rem',
                  fontWeight:'500'
                }}          
              >{name}</Typography>
              <Typography
                sx={{
                  fontFamily:'var(--text-font)',
                  fontSize:'1.2rem',
                  textTransform:'capitalize',
                  '@media screen and (max-width: 762px)':{
                    fontSize:'1rem'
                  }
                }}
              >{text}</Typography>
            </Box>
            </ScrollFadeInSlideUp>
        )
      }

  return (
    <Box
      sx={{
        width: '90%',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)', // 3 columns for large screens
        gridTemplateRows: 'auto', // Automatically adjust row height
        gap: '2rem', // Spacing between grid items
        margin: '2rem auto',
        '@media screen and (max-width: 762px)': {
          gridTemplateColumns: 'repeat(1, 1fr)', // Switch to 1 column on smaller screens
          gap: '1rem', // Adjust spacing for smaller screens
        },
      }}
    >
      {purposeData.map((item, index) => (
        <Box key={index} // Add a unique key for each item
          sx={{
            textAlign: 'center',
            gridColumn: item.gridColumn, // Use gridColumn for large screens
            gridRow: item.gridRow, // Use gridRow for large screens
            '@media screen and (max-width: 762px)': {
              gridColumn: '1', // Override to single column on smaller screens
              gridRow: 'auto', // Automatically adjust row position
            },
          }}
        >
          <PurposeContainer name={item.name} text={item.text} />
        </Box>
      ))}
    </Box>
  )
}

export default AboutPurpose